import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/components/LanguageProvider";
import useReveal from "@/hooks/useReveal";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import InvestorPitch from "@/components/InvestorPitch";
import GccFootprint from "@/components/GccFootprint";
import Factory from "@/components/Factory";
import Comparison from "@/components/Comparison";
import Projects from "@/components/Projects";
import Certifications from "@/components/Certifications";
import Vision from "@/components/Vision";
import Partners from "@/components/Partners";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import BoothIntake from "@/components/BoothIntake";

function Site() {
  useReveal();
  return (
    <div className="App relative" data-testid="site-root">
      <Navbar />
      <main>
        <Hero />
        <InvestorPitch />
        <GccFootprint />
        <Factory />
        <Comparison />
        <Projects />
        <Certifications />
        <Vision />
        <Partners />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/booth" element={<BoothIntake />} />
          <Route path="/" element={<Site />} />
          <Route path="*" element={<Site />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}
